import { ElementType } from 'react'

import { Append } from 'elements/Append'
import { AudioRecord } from 'elements/AudioRecord'
import { Avatar } from 'elements/Avatar'
import { AxleIframe } from 'elements/AxleIframe'
import { Box } from 'elements/Box'
import { CheckboxGroup } from 'elements/CheckboxGroup'
import { CheckboxGroupImage } from 'elements/CheckboxGroupImage'
import { CheckboxGroupSet } from 'elements/CheckboxGroupSet'
import { ConditionalAgreementBlock } from 'elements/ConditionalAgreementBlock'
import { CreditCard } from 'elements/CreditCard'
import { DatePicker } from 'elements/DatePicker'
import { Divider } from 'elements/Divider'
import { FileUpload } from 'elements/FileUpload'
import { MapAddress } from 'elements/MapAddress'
import { MapAddressAutocomplete } from 'elements/MapAddressAutocomplete'
import { MapSelect } from 'elements/MapSelect'
import { MarkDown } from 'elements/MarkDown'
import { NextButton } from 'elements/NextButton'
import { RadioGroup } from 'elements/RadioGroup'
import { RadioGroupImage } from 'elements/RadioGroupImage'
import { RadioGroupSet } from 'elements/RadioGroupSet'
import { ReCaptcha } from 'elements/ReCaptcha'
// In feature need to be deleted
import { RichText } from 'elements/RichText'
import { SaveFlowButton } from 'elements/SaveFlowButton'
import { SearchAutocomplete } from 'elements/SearchAutocomplete'
import { Select } from 'elements/Select'
import { Signature } from 'elements/Signature'
import { SubmitButton } from 'elements/SubmitButton'
import { SummaryView } from 'elements/SummaryView'
import { Switch } from 'elements/Switch'
import { Text } from 'elements/Text'
import { TextArea } from 'elements/TextArea'
import { TextField } from 'elements/TextField'
import { TimePicker } from 'elements/TimePicker'
import { YearPicker } from 'elements/YearPicker'

const componentsMap: Record<string, ElementType> = {
  TextField,
  NextButton,
  SubmitButton,
  Select,
  DatePicker,
  RadioGroup,
  RadioGroupImage,
  RadioGroupSet,
  Box,
  Append,
  Text,
  TimePicker,
  Divider,
  Avatar,
  CheckboxGroup,
  CheckboxGroupImage,
  CheckboxGroupSet,
  FileUpload,
  MapAddress,
  MapSelect,
  SummaryView,
  TextArea,
  CreditCard,
  Signature,
  MarkDown,
  ConditionalAgreementBlock,
  YearPicker,
  SaveFlowButton,
  Switch,
  AudioRecord,
  RichText,
  MapAddressAutocomplete,
  SearchAutocomplete,
  ReCaptcha,
  AxleIframe,
}

export default componentsMap
